import { createContext } from 'react';

interface MenuContext {
    adaptive: boolean;
    active: string | null;
    expanded: string[];
}

const defaultValues: MenuContext = {
    adaptive: true,
    active: null,
    expanded: []
};

const menuContext = createContext(defaultValues);

export default menuContext;
